import {
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Brightness4,
  Brightness7,
  AccountCircle,
  ExitToApp,
  Settings,
} from "@mui/icons-material";
import { useState } from "react";

export default function AppBar({ user, toggleTheme, onLogout }) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <MuiAppBar
      position="sticky"
      elevation={1}
      sx={{
        bgcolor: "background.paper",
        color: "text.primary",
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Toolbar sx={{ px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <Avatar
            src="/img/logo-bensco.png"
            alt="Logo"
            sx={{ width: 40, height: 40, mr: 2 }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 700, letterSpacing: 0.5 }}
          >
            KPI Bensco
          </Typography>
        </Box>

        <IconButton onClick={toggleTheme} color="inherit">
          {isDarkMode ? <Brightness7 /> : <Brightness4 />}
        </IconButton>

        <IconButton onClick={handleMenu} size="small" sx={{ ml: 2 }}>
          <AccountCircle fontSize="large" />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            elevation: 2,
            sx: {
              mt: 1.5,
              minWidth: 200,
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem disabled>
            <Typography variant="body2">
              {user.username} ({user.role})
            </Typography>
          </MenuItem>
          <Divider />
          <MenuItem>
            <Settings sx={{ mr: 1 }} /> Pengaturan
          </MenuItem>
          <MenuItem onClick={onLogout}>
            <ExitToApp sx={{ mr: 1 }} /> Keluar
          </MenuItem>
        </Menu>
      </Toolbar>
    </MuiAppBar>
  );
}
